import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-error504',
	templateUrl: './error504.component.html',
	styleUrls: ['./error504.component.scss'],
})
export class Error504Component {

	private readonly RETURN_URL: string = 'returnUrl';
	private m_returnUrl: string;

	constructor(
		private m_router: Router,
		private m_activatedRoute: ActivatedRoute,
	) {
		this.m_activatedRoute.queryParams.subscribe({
			next: (params) => {
				this.m_returnUrl = params[this.RETURN_URL];
			},
		});
	}

	/**
	 * Es wird auf die returnURL gewechselt.
	 */
	public reload_Click(): void {
		this.m_router.navigate([this.m_returnUrl]);
	}

}
